/*
Monotype Foundry Platform API
Version 1.0.0

Definition: ChangePassword

Properties:
  email: string (required), minLength: 1
*/

var ChangePassword = (function () {
  function validateChangePassword (arg) {
    // Validate email
    if (!arg.email) {
      throw new Error('ChangePassword.email: Missing property')
    }
    if (arg.email && !(typeof arg.email === 'string')) {
      throw new Error('ChangePassword.email: Wrong type: Got \'' + (typeof arg.email) + '\', but expected: \'string\'')
    }
    if (arg.email && !(arg.email.length >= 1)) {
      throw new Error('ChangePassword.email: Minimum length 1, but got: ' + arg.email.length)
    }
  }
  function buildChangePassword (arg) {
    var ChangePassword = arg
    // Complete email
    // Expected Type: string
    ChangePassword.email = ChangePassword.email || ''
    return ChangePassword
  }
  return {
    validate: validateChangePassword,
    build: buildChangePassword
  }
})()

module.exports = ChangePassword
